import React from 'react';

const NsfwTag = () => {
    return (
        <span style={{color: 'red', paddingRight: '5px'}}>[NSFW]</span>
    )
}

export default NsfwTag;